import React from 'react';
import BaseLayout from '../layouts/BaseLayout.jsx';
import Basic3DIconsList from '../components/Basic3DIconsList.jsx';

const Basic3DIconsPage = () => {
  return (
    <BaseLayout
      title="Basic 3D Icons"
      description="Browse and explore our beautiful Basic 3D icons collection."
      showHeader={true}
    >
      <div className="page-container-with-top-margin">
        <Basic3DIconsList />
      </div>
    </BaseLayout>
  );
};

export default Basic3DIconsPage;